// Fetches the GLOBAL feature flag boolean map from /client/feature-flags
// and hydrates the redux slice. Called on app boot (alongside the session
// fetch) and on foreground after a long background period — the server
// caches aggressively (10s L1 / 5min DynamoDB) so re-fetches are cheap.

import { apiGet } from '../../utilities/apiClient';
import { SET_FEATURE_FLAGS, SET_FEATURE_FLAGS_LOADING } from '../constants';
import { getSessionIds } from './_sessionIds';

export const fetchFeatureFlags = () => async (dispatch: any) => {
  const { accountId, cognitoId } = getSessionIds();
  if (!accountId || !cognitoId) return;
  dispatch({ type: SET_FEATURE_FLAGS_LOADING, payload: true });
  try {
    const res = await apiGet(`/feature-flags/${accountId}/${cognitoId}`);
    const flags = res?.payload?.flags ?? {};
    dispatch({ type: SET_FEATURE_FLAGS, payload: { flags } });
  } catch {
    // Swallow — initial state already preserves current behavior (features
    // stay visible until we hear otherwise). A failed fetch leaves the
    // existing snapshot intact and lets the next foreground retry.
    dispatch({ type: SET_FEATURE_FLAGS_LOADING, payload: false });
  }
};

// Matches the server's own 5-minute DynamoDB cache — a sooner re-fetch
// could not see a newer value anyway.
export const FEATURE_FLAGS_MAX_AGE_MS = 5 * 60 * 1000;

// Foreground return: re-fetch only when the snapshot is stale (or no fetch
// has succeeded yet) and nothing is already in flight.
export const refreshFeatureFlagsIfStale = () => async (dispatch: any, getState: () => any) => {
  const { fetching, fetchedAt } = getState().featureFlags || {};
  if (fetching) return;
  if (fetchedAt && Date.now() - fetchedAt < FEATURE_FLAGS_MAX_AGE_MS) return;
  return dispatch(fetchFeatureFlags());
};
